import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../../shared/http-utils';
import {URL_BASE} from '../../core/constants';
import {map} from 'rxjs/operators';
import {VehicleType, VehicleTypeRegion} from './vehicle-type.model';

@Injectable()
export class VehicleTypeService {

  private VEHICLE_TYPE_URI = `${URL_BASE}/api/decarbonization/vehicle-types`;

  constructor(
    private http: HttpClient
  ) {
  }

  public getVehicleTypes(): Observable<Array<VehicleType>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => VehicleType.fromDto(data)))
    );
  }

  public getRemovableVehicleTypeIds(): Observable<Array<string>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/removable`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => data.toString()))
    );
  }

  public getSelfVehicleTypes(): Observable<Array<VehicleTypeRegion>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/self`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => VehicleTypeRegion.fromDto(data)))
    );
  }

  public getSelfRemovableVehicleTypeRegionIds(): Observable<Array<string>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/self/removable`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => data.toString()))
    );
  }

  public createVehicleType(vehicleTypeCreationRequest: string) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}`;

    return this.http.post(url, {label: vehicleTypeCreationRequest}, {headers}).pipe(
      map(result => VehicleType.fromDto(result))
    );
  }

  public addOwnRegionVehicleType(vehicleType: VehicleType) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/self/${vehicleType.id}`;

    return this.http.put(url, {}, {headers}).pipe(
      map(result => VehicleType.fromDto(result))
    );
  }

  public deleteVehicleType(vehicleType: VehicleType) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/${vehicleType.id}`;

    return this.http.delete(url, {headers});
  }

  public deleteOwnRegionVehicleType(vehicleTypeRegion: VehicleTypeRegion) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.VEHICLE_TYPE_URI}/self/${vehicleTypeRegion.id}`;

    return this.http.delete(url, {headers});
  }
}
